import {
    useMutation,
    UseMutationResult,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import requests from 'app/requests/Order/OrderBilling.requests'
import {
    OutgoingInvoice,
} from 'app/Apps/OrderManagement/Orders/orders.types'
import simpleApi from 'app/services/simpleApi'

type RequestParams = {
    orderNumber: string,
    invoice: OutgoingInvoice,
}

const useRemoveInvoice = (
    onSuccess: (params: OutgoingInvoice) => void,
): UseMutationResult<unknown, unknown, RequestParams> => {
    const token = useJWTToken()
    const {
        onSuccess: onSuccessRemoveInvoice,
        onError,
    } = useHandleStatusRequest({
        id: 'OutgoingInvoice',
        title: 'Remove OutgoingInvoice',
        onSuccess,
    })

    return useMutation({
        mutationFn: ({
            orderNumber,
            invoice,
        }: RequestParams) => {
            return simpleApi({
                ...requests.deleteOutgoingInvoice({
                    orderNumber,
                    outgoingInvoiceId: invoice.id,
                }),
                token,
            })
        },
        onSuccess: onSuccessRemoveInvoice,
        onError,
    })
}

export default useRemoveInvoice
